<template>
    <div class="container">
        <img v-if="icon" :src="icon" class="img" alt="">
        <div v-if="!icon" class="left">
            <div class="name">{{ name }}</div>
        </div>
        <div class="right">
            <div class="title">{{ title }}</div>
            <div class="datacontainer">
                <div class="data">{{ data }}</div>
                <div class="unit">{{ unit }}</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MonitorItem",
        props: ["icon", "name", "title", "data", "unit"],
    };
</script>

<style lang="less" scoped>
    .container {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
    }

    .img {
        .w(84);
        .h(84);
    }

    .left {
        .w(84);
        .h(84);
        background: rgba(0, 43, 102, 0.3);
        display: flex;
        flex-direction: center;
        justify-content: center;
        align-items: center;
    }

    .name {
        color: #fff;
        font-size: 28rem;
        font-family: SourceHanSansCN-Bold;
    }

    .right {
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: flex-start;
        margin-left: 24rem;
    }

    .title {
        font-size: 16rem;
        color: #666;
    }

    .datacontainer {
        color: #333;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: baseline;
    }

    .data {
        font-size: 48rem;
        font-family: SourceHanSansCN-Bold;
    }

    .unit {
        font-size: 24rem;
        font-family: SourceHanSansCN-Bold;
    }
</style>